<div class="occupancy ofe-accordion">
  <ngb-accordion #a="ngbAccordion">
    <ngb-panel id="occupancy-panel">
      <ng-template ngbPanelHeader let-opened="opened">
        <div class="occupancy__header">
          <h5 class="occupancy__heading">Soluzioni per <span [innerHtml]="guestString"></span></h5>
          <div class="occupancy__toggle">
            <button class="btn" [class]="opened ? 'btn--light-blue-outline' : 'btn--light-blue' " ngbPanelToggle>
              {{opened ? 'fatto' : 'Cambia'}}
            </button>
          </div>
        </div>
      </ng-template>

      <!-- Numero di Adulti -->
      <ng-template ngbPanelContent>
        <div class="occupancy__inner">
          <form name="occupancyForm" #form="ngForm" novalidate (ngSubmit)=setNewAges()>
            <div class="container">
              <div class="row occupancy__row occupancy__row--adults align-items-center">
                <div class="occupancy__col col-6 col-sm-4 col-lg-3">
                  <h4 class="occupancy__row__title">Adulti</h4>
                  <small class="occupancy__row__description">(Dai 18 anni in su)</small>
                </div>
                <div class="occupancy__col col-6 col-sm-4 col-lg-3">
                  <div class="spinner-counter">
                    <span class="spinner-counter__btn" [ngClass]="{'disabled': adultsAges?.length <= 1}"
                      (click)="adultsAges?.length > 1 ? removeAdult() : null">
                      <i class="icon-minus"></i>
                    </span>
                    <input class="spinner-counter__count" name="adultsNumber" [(ngModel)]="adultsAges.length" readonly>
                    <span class="spinner-counter__btn" [ngClass]="{'disabled': maxGuestNumberReached()}"
                      (click)="maxGuestNumberReached() ? null : addAdult()">
                      <i class="icon-plus"></i>
                    </span>
                  </div>
                </div>
              </div>
              <!-- Numero di Bambini -->
              <div class="row occupancy__row occupancy__row--children align-items-center">
                <div class="occupancy__col col-6 col-sm-4 col-lg-3">
                  <h4 class="occupancy__row__title">Bambini</h4>
                  <small class="occupancy__row__description">(Meno di 18 anni)</small>
                </div>
                <div class="occupancy__col col-6 col-sm-4 col-lg-3">
                  <div class="spinner-counter">
                    <span class="spinner-counter__btn" [ngClass]="{'disabled': childrenAges?.length == 0}"
                      (click)="removeChild()">
                      <i class="icon-minus"></i>
                    </span>
                    <input class="spinner-counter__count" name="childrenNumber" [(ngModel)]="childrenAges.length"
                      readonly>
                    <span class="spinner-counter__btn" [ngClass]="{'disabled': maxGuestNumberReached()}"
                      (click)="maxGuestNumberReached() ? null : addChild()">
                      <i class="icon-plus"></i>
                    </span>
                  </div>
                </div>
              </div>

              <div class="row occupancy__row align-items-center" *ngIf="childrenAges.length">
                <div class="col occupancy__col">
                  <div class="form-group">
                    <p class="occupancy__row__description">Indica l'età dei bambini alla data di partenza</p>
                    <div class="form-row">
                      <div class="form-group-custom mt-3 col-6 col-sm-3 col-lg-4"
                        *ngFor="let age of childrenAges; let i = index; trackBy: trackByAges">
                        <input class="form-control form-control-custom" type="number" [(ngModel)]="childrenAges[i]"
                          [name]="'age-'+i" class="form-control" id="age-{{i}}" [min]="0" [max]="17" #age="ngModel"
                          required (blur)="checkAgeInput(i)">
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row occupancy__row align-items-center">
                <div class="col-sm-6 occupancy__col text-left">
                  <button class="btn btn--brand-color-03 occupancy__confirm">Conferma</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </ng-template>
    </ngb-panel>
  </ngb-accordion>
</div>